import axios from 'axios'
import {ResponseObject} from '../../../../../models'
import {FurnitureModel} from '../models'
const BASEURL = process.env.REACT_APP_DEV_API_HOTELERIA_URL

export async function getFurnitureByIdService(id: string | undefined | number) {
  return await axios.get<ResponseObject<FurnitureModel>>(`${BASEURL}/furniture/getFurnitureById`, {
    params: {
      Id: id,
    },
  })
}
